<template>
  <van-pagination
    v-if="total / pageSize > 1"
    v-model="page"
    @change="handleCurrentChange"
    class="search-pagination"
    :total-items="total"
    :items-per-page="pageSize"
    force-ellipses
    page-count
  />
</template>
<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    page: {
      set: function (value) {
        this.$emit("update:currentPage", value);
      },
      get: function () {
        return this.currentPage;
      },
    },
    size: {
      set: function (value) {
        this.$emit("update:pageSize", value);
      },
      get: function () {
        return this.pageSize;
      },
    },
  },
  methods: {
    handleCurrentChange() {
      this.$emit("change", this.page, this.size);
    },
  },
};
</script>
<style lang="scss" scoped>
.search-pagination {
  width: 400px;
  padding: 100px 0 30px;
  margin: auto;
}
</style>
